export default function MatchCard({ match }) {
  return (
    <div data-testid="match-card" className="border-2 border-[#E3BC55] rounded-2xl bg-black px-6 py-5 text-center">
      <p className="text-slate-400 font-semibold text-sm uppercase tracking-wider">Campionato Selezionato</p>
      <p className="text-[#E3BC55] font-heading font-bold text-2xl mt-0.5">{match.league}</p>
      <div className="flex items-center justify-center gap-4 mt-4">
        <span className="text-white font-heading font-bold text-2xl sm:text-3xl flex-1 text-right leading-tight">{match.home_team}</span>
        <span className="text-[#E3BC55] font-heading font-bold text-lg uppercase">vs</span>
        <span className="text-white font-heading font-bold text-2xl sm:text-3xl flex-1 text-left leading-tight">{match.away_team}</span>
      </div>
    </div>
  );
}
